import { Reveal } from "./motion";

const SectionHead = ({ eyebrow, title, sub, align = "left", testid }) => (
    <Reveal className={align === "center" ? "text-center" : ""}>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta">{eyebrow}</p>
        <h2
            data-testid={testid}
            className="font-serif mt-3 text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:text-5xl"
        >
            {title}
        </h2>
        {sub && (
            <p className={`mt-4 max-w-2xl text-base leading-relaxed text-[#525B53] sm:text-lg ${align === "center" ? "mx-auto" : ""}`}>
                {sub}
            </p>
        )}
    </Reveal>
);

export default SectionHead;
